import React,{useEffect,useState} from "react";
import useImagenesCarta from "../Hooks/useImagenesCarta";
import WhatsappButton from "../Components/WhatsappButton";
import Loader from "../Components/Loader";
import styled from "styled-components";
import Popups from "../Components/Carta/Popups";
import ReactGA from 'react-ga';
import useHorariosCarta from "../Hooks/useHorariosCarta";
import { checkCartasNoche } from "../Utils/Dates";
import useCartaPagePhotos from "../Hooks/useCartaPagePhotos";


const ResponsiveImage=styled.img`
display:block;
background-repeat: no-repeat;
object-fit: fill;
width: 100vw;
height:auto;
max-width:100%;`;

const Index=()=>
{
    const Photos = useCartaPagePhotos();

    if(Photos===undefined || Photos.length === 0) 
        return <Loader/>

    return (<>
        <WhatsappButton number="5491138141940" show={true} bottom={10}/>
        <section className="Carta">
        <Popups/>
        <>{Photos.map( photo => 
        {   
            const {id, source }=photo;
    
            return <ResponsiveImage key={id} alt="Imagen de carta"  src={source}/>
        })}</>
        </section>
    </>);
}

export default Index;
